export const CHART_TYPE = {
  BARS: 'bars',
  ARC: 'arc'
};
